module.exports = __webpack_public_path__ + "static/img/11.345eb70.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/11.png
// module id = 0Mkb
// module chunks = 0